import { gql } from '../../utils/GraphQLUtil';

export default gql`
  query getPetBreeds {
    getPetBreeds {
       id
       uuid
       name
       species
       size
       type
    }
  }
`;